// import 'core-js/fn/string/ends-with';
// import 'core-js/es6/string.js'
// import 'core-js/es7/string.js';
// import 'core-js/es7/object.js';

import 'url-search-params-polyfill';
import 'core-js/client/shim.js';




// WEBPACK FOOTER //
// ./src/polyfills.js